'use strict';
import isFunction from 'lodash/isFunction';
import isString from 'lodash/isString';
import isUndefined from 'lodash/isUndefined';
import noop from 'lodash/noop';

module.exports = [
  DomainListFunction];

function DomainListFunction() {
  return {
    restrict: 'E',
    template: generateTemplate,
    scope: {
      list: '=?',
      selectedEntry: '=?',
      excludeFilter: '=?',
      excludeFilters: '=?',
      loadAction: '&?',
      onSelect: '&?',
      autoLoad: '@'
    },
    controller: ['$scope', '$attrs', DomainListController]
  };
}

function DomainListController($scope, $attrs) {
  initDisplayValue();

  if (typeof $attrs.onSelect !== 'undefined') {
    $scope.onSelectInternal = function (item) {
      defaultSelect(item);
      var onSelect = $scope.onSelect();
      if (isFunction(onSelect)) {
        onSelect(item);
      }
    }
  } else {
    $scope.onSelectInternal = defaultSelect;
  }

  if (isUndefined($attrs.list) && isUndefined($attrs.loadAction)) {
    throw new Error('Directive[domainList]: You must either a provide an existing list or a load function!')
  } else if (isUndefined($attrs.loadAction)) {
    initLoader();
  }


  //TODO: this is hacky. clean it up
  function initDisplayValue() {
    $scope.getDisplayValue = function (item) {
      return item.toString();
    };

    $attrs.$observe('toStringMethod', function (methodName) {
      if (isString(methodName)) {
        $scope.getDisplayValue = function (item) {
          if (isFunction(item[methodName])) {
            $scope.getDisplayValue = function (item) {
              return item[methodName]();
            };

            return item[methodName]();
          } else {
            $scope.getDisplayValue = function (item) {
              return item.toString();
            };
          }
        };
      }
    })
  }

  function initLoader() {
    //TODO: this doesn't always initialize in time. Need to improve algorithm for initial loading
    if (typeof $attrs.bindList === 'undefined' || $attrs.bindList == 'true') {
      $scope.loadAction = function () {
        var getList = $scope.loadAction();
        if (isFunction(getList)) {
          bindList(getList());
        }
      };

      if ($attrs.autoLoad === 'true') {
        $scope.loadAction();
      }
    } else {
      $scope.loadAction = noop;
    }
  }

  function bindList(list) {
    list.$bindToScope($scope, 'list');
  }

  function defaultSelect(item) {
    $scope.selectedEntry = item;
  }
}

function generateTemplate($element, $attrs) {
  var htmlBody = [];

  htmlBody.push(
    '<ion-list>',
    '<div class="item item-icon-right double-line"',
    ' ng-click="onSelectInternal(item)"',
    ' ng-class="{ \'item-selected\': item.$id===selectedEntry.$id}"',
    ' ng-repeat="item in list track by item.$id'
  );

  if (typeof $attrs.excludeFilter !== 'undefined') {
    htmlBody.push(' | excludeDomain:excludeFilter');
  }

  if (typeof $attrs.excludeFilters !== 'undefined' && typeof $attrs.excludeFiltersSize !== 'undefined') {
    for (var i = 0; i < $attrs.excludeFiltersSize; i++) {
      htmlBody.push(' | excludeDomain:excludeFilters[', i, ']');
    }
  }

  if (typeof $attrs.useFilter === 'undefined' || $attrs.useFilter == "true") {
    htmlBody.push(' | filterDomainAsString:filterValue');
  }

  htmlBody.push(
    '">',
    '<span ng-bind="getDisplayValue(item)"></span>',
    '<i class="icon" ng-class="{\'ion-ios-checkmark-empty choose-check-white\': item.$id===selectedEntry.$id}"></i>',
    '</div>',
    '</ion-list>'
  );

  return htmlBody.join('');
}


// WEBPACK FOOTER //
// ./src/js/domain-directives/DomainListDirective.js